// Caricamento condiviso di Google Maps (libreria places) per gli autocomplete citta'
// di homepage, pagina offerte e filtri avanzati.
//
// Un unico punto di caricamento per tutto il sito, perche' il Loader di
// @googlemaps/js-api-loader e' un singleton: se due pagine lo creassero con opzioni
// diverse, la seconda riceverebbe "Loader must not be called again with different
// options" e il suo autocomplete smetterebbe di funzionare.
//
// La promessa sta a livello di modulo, quindi sopravvive ai cambi di pagina: Google
// Maps si scarica una sola volta per tutta la visita. Va chiamata solo dal browser,
// in risposta a un'azione dell'utente (focus o digitazione nel campo citta').

let placesPromise = null

export function loadPlaces(apiKey, language) {
  if (!placesPromise) {
    placesPromise = import('@googlemaps/js-api-loader')
      .then(({ Loader }) => new Loader({
        apiKey,
        language,
        version: 'weekly'
      }).importLibrary('places'))
      .then(({ AutocompleteService, PlacesService }) => ({
        service: new AutocompleteService(),
        // PlacesService accetta un div al posto di una Map: passandogli una Map
        // si creava una mappa mai mostrata, che faceva scaricare anche map.js
        servicePlaces: new PlacesService(document.createElement('div'))
      }))
      .catch((err) => {
        // azzeriamo la promessa fallita, cosi' la chiamata successiva ritenta
        placesPromise = null
        console.log(err.toString())
        throw err
      })
  }
  return placesPromise
}
